import React, { useState, useRef, useEffect } from 'react';
import './MainPasswordForm.css';

const MainPasswordForm = (props) => {
    const [activeTab, setActiveTab] = useState('architecture');
    const [password, setPassword] = useState('');
    const [showPasswordForm, setShowPasswordForm] = useState(false);
    const passwordInputRef = useRef(null);

    useEffect(() => {
        if (passwordInputRef.current) {
            passwordInputRef.current.focus();
        }
    }, []);

    const handlePasswordChange = (element) => {
        setPassword(element.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (props.handleSubmitClick) {
            props.handleSubmitClick(
                e,
                props.setShowImages,
                props.setShowVideos,
                props.setImages,
                props.setVideos,
                props.setShowHtmlDoc,
                props.setHtmlDoc,
                props.setYouTubeList,
                props.setShowYouTubeList,
                password,
                props.baseDomainUrl,
                props.serviceUrlResource,
                props.setShowInputForm,
                props.setShowAudio,
                props.setAudio,
                props.setAnalogArchiveMediaFolder,
                props.setServerFolder,
                props.setShowAnalogArchiveMediaFolder,
                props.setShowServerFolder,
                props.setShowDeleteForm,
                props.setShowAdminPanel,
                props.setSubmitError
            );
        } else {
            console.log('Password submitted:', password);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSubmit(e);
        }
    };


    return (
        <div className="main-container">
            <div className="jaemzware-content">
                <h1>jaemzware llc</h1>
                <p>no databases. no registration. free. ephemeral.</p>

                <h1>current projects</h1>
                <table>
                    <tbody>
                    <tr>
                        <td>
                            <p>nodejs</p>
                        </td>
                        <td>
                            <ul>
                                <li>
                                    <a href="https://stuffedanimalwar.com" target="_blank" rel="noopener noreferrer">stuffed animal war</a><br />
                                    <span>production-grade real-time collaboration platform with zero data persistence. websocket architecture handles synchronized multi-user canvas, chat, and interactive elements across devices. shared images and videos stream as binary data directly to clients - no cloud storage, no file references, ephemeral like chat messages. stateless design enables instant client reconnection - unplug the server mid-session and clients resume seamlessly when it returns. customizable chat rooms via JSON theme files per endpoint - edit photos, videos, auto-responses, and game elements through /crud interface for onboard media configuration. platform-agnostic deployment: run in Docker on your laptop at home or any wifi hotspot, scale down to $15 raspberry pi zero 2 w running alongside analogarchivejs via nginx reverse proxy (stuffedanimalwar.local → port 55556, stuffedanimalwar.local:55557 → analogarchive), or scale up to production apache2 infrastructure (UFW firewall, fail2ban, mod_evasive rate limiting, SSL management). production deployment handles distributed attacks with worker process tuning and connection rate limiting. production operations: systemd service configuration, journalctl monitoring, health checks. proves that distributed systems don't require cloud vendor lock-in - deploy anywhere from laptop to edge IoT devices to hardened production servers. live demo running on apache2 production infrastructure.</span><br />
                                    <a href="https://github.com/jaemzware/stuffedanimalwar" target="_blank" rel="noopener noreferrer">github</a><br />
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>nodejs</p>
                        </td>
                        <td>
                            <ul>
                                <li>
                                    <a href="https://analogarchive.com" target="_blank" rel="noopener noreferrer">analogarchivejs</a><br />
                                    <span>self-hosted media streaming server with intelligent metadata extraction and dual-storage architecture. recursively scans local drives and backblaze b2 buckets for audio files, extracts id3 tags and embedded artwork, presents sorted library with auto-play queue. efficient architecture: memory-efficient direct streaming without buffering entire files in ram. handles large collections on resource-constrained hardware (confirmed on raspberry pi zero 2 w) and scales to production apache2 deployments with concurrent users. platform portability: run in Docker on your laptop for personal use, deploy to raspberry pi zero 2 w alongside stuffedanimalwar via nginx reverse proxy on shared hardware (nginx, embedded/iot), or scale up to production apache2 deployments (production cloud) with concurrent users. includes cors proxy for cloud file access, SSL certificate auto-generation, systemd service management. production deployment includes security hardening: firewall configuration, connection rate limiting, and attack mitigation. alternative to spotify/plex for scenarios requiring full infrastructure control without vendor lock-in or usage tracking. live demo running on apache2 production infrastructure.</span><br />
                                    <a href="https://github.com/jaemzware/analogarchivejs" target="_blank" rel="noopener noreferrer">github</a><br />
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>cross-platform</p>
                        </td>
                        <td>
                            <ul>
                                <li>
                                    <a href="https://apps.apple.com/us/app/skatepark-map/id1099516729" target="_blank" rel="noopener noreferrer">Skatepark Map (iOS)</a> | <a href="https://skatecreteordie.com" target="_blank" rel="noopener noreferrer">Skatepark Map (Web skatecreteordie.com)</a> <br />
                                    <span>cross-platform location-aware mapping system (Swift/Kotlin/JavaScript) with single-source architecture: one JSON file updates web, iOS, and Android simultaneously via single scp call - bypassing app store deployment delays. GPS tracking with path visualization, distance/time measurement - navigated complex all-ages app store approval requiring demonstration video for Google Play (share id: android). instant-update pipeline: CSV → Python script → JSON → deploy to all platforms. web submission form extracts GPS from photo EXIF, stores to backblaze b2, human verification before deployment. advanced filtering by metadata (builder, amenities, type). no registration, no tracking, free always. template architecture designed for rapid adaptation to any location-based dataset (disc golf, climbing spots, business locations). trademark registered.</span><br />
                                    <a href="https://github.com/jaemzware/skatecreteordie" target="_blank" rel="noopener noreferrer">github (ios)</a><br />
                                    <a href="https://github.com/jaemzware/skatecreteordie.com" target="_blank" rel="noopener noreferrer">github (web)</a><br />
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>objective c</p>
                        </td>
                        <td>
                            <ul>
                                <li>
                                    <a href="https://itunes.apple.com/us/app/couch-game/id775551900?mt=8" target="_blank" rel="noopener noreferrer">couch game</a><br />
                                    <span>80s style arcade game.</span>
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>domains</p>
                        </td>
                        <td>
                            <ul>
                                <li>
                                    <a href="https://analogarchive.com" target="_blank" rel="noopener noreferrer">analogarchive.com</a>
                                </li>
                                <li>
                                    <a href="https://jaemzware.com" target="_blank" rel="noopener noreferrer">jaemzware.com</a>
                                </li>
                                <li>
                                    <a href="https://skatecreteordie.com" target="_blank" rel="noopener noreferrer">skatecreteordie.com</a>
                                </li>
                                <li>
                                    <a href="https://stuffedanimalwar.com" target="_blank" rel="noopener noreferrer">stuffedanimalwar.com</a>
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>deployment</p>
                        </td>
                        <td>
                            <ul>
                                <li>
                                    <span>stuffedanimalwar and analogarchivejs run simultaneously on same hardware (raspberry pi zero 2 w, and up) via nginx reverse proxy: stuffedanimalwar.local (port 55556) for collaboration, stuffedanimalwar.local:55557 for media streaming. complete portable media and collaboration stack on $15 hardware. note: some wifi networks may block non-standard ports.</span>
                                </li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>consulting</p>
                        </td>
                        <td>
                            <ul>
                                <li>
                                    <span>i already built these. i can drop a piece of one into your site and show you how it runs. no black box, no lock-in — you get a walkthrough of how it works and how to maintain it.</span><br />
                                    <span>&nbsp;</span><br />
                                    <span>from stuffed animal war: live drawing canvas, real-time chat rooms, multiplayer sync</span><br />
                                    <span>from analogarchivejs: audio streaming, cover art + metadata, folder-based library</span><br />
                                    <span>from skatepark map: interactive map, location listings, ios/android</span><br />
                                    <span>&nbsp;</span><br />
                                    <span>add one piece to your site: sliding scale, quoted up front</span><br />
                                    <span>custom work beyond that: $150/hr</span><br />
                                    <span>tutoring &amp; mentoring, one-on-one: sliding scale</span><br />
                                    <span>&nbsp;</span><br />
                                    <span>30 years building and testing systems - from hp firmware (1997) through microsoft windows xp (sdet, printer subsystem automation), to current open source projects. ships reliable code because testing is built into development process, not bolted on after.</span><br />
                                </li>
                            </ul>
                            <a href="mailto:jaemzware@hotmail.com">jaemzware@hotmail.com</a> <a href="https://www.linkedin.com/in/jimarasim/" target="_blank" rel="noopener noreferrer">LinkedIn</a><br />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div className="jaemzware-content" style={{ marginTop: '32px', paddingTop: '24px', borderTop: '1px solid rgba(255, 255, 255, 0.2)' }}>
                <h1>aude</h1>
                <p>dynamic content presentation platform. share id retrieves JSON configuration from database - only data persisted. generates custom layouts: photo galleries, audio players, video embeds, HTML documents. try sample share ids:</p>
                <ul style={{ marginTop: '16px' }}>
                    <li style={{ marginBottom: '8px' }}>
                        <span style={{ color: '#fbbf24', fontSize: '16px' }}>marg</span>
                        <span> - marginal way skatepark foundation photo archive</span>
                    </li>
                    <li style={{ marginBottom: '8px' }}>
                        <span style={{ color: '#fbbf24', fontSize: '16px' }}>soundgarden</span>
                        <span> - Soundgarden - Outshined / Spoonman (Live at Lumen Field ft. Taylor Momsen & Mike McCready)</span>
                    </li>
                </ul>
            </div>

            <div id="passworddiv" className="App" style={{ marginTop: '24px' }}>
                <form onSubmit={(e) => {
                    e.preventDefault();
                    if (props.handleSubmitClick) {
                        props.handleSubmitClick(
                            e,
                            props.setShowImages,
                            props.setShowVideos,
                            props.setImages,
                            props.setVideos,
                            props.setShowHtmlDoc,
                            props.setHtmlDoc,
                            props.setYouTubeList,
                            props.setShowYouTubeList,
                            props.password,
                            props.baseDomainUrl,
                            props.serviceUrlResource,
                            props.setShowInputForm,
                            props.setShowAudio,
                            props.setAudio,
                            props.setAnalogArchiveMediaFolder,
                            props.setServerFolder,
                            props.setShowAnalogArchiveMediaFolder,
                            props.setShowServerFolder,
                            props.setShowDeleteForm,
                            props.setShowAdminPanel,
                            props.setSubmitError
                        );
                    }
                }}>
                    <input
                        data-testid="password"
                        type="password"
                        name="password"
                        id="password"
                        placeholder="share id"
                        onChange={(element) => props.handlePasswordChange(element, props.setPassword)}
                        ref={passwordInputRef}
                    />
                    <input
                        data-testid="submit"
                        type="submit"
                        name="submit"
                        id="submit"
                        value="GO!"
                    />
                </form>
                {props.submitError && (
                    <p data-testid="submit-error" style={{ color: '#f87171', marginTop: '12px' }}>
                        {props.submitError}
                    </p>
                )}
            </div>
        </div>
    );
};

export default MainPasswordForm;